import * as d3 from 'd3';
import { parseISO } from 'date-fns';

export const sampleDataToWeekly = (
  data: Array<{ date: string; price: number }>
) => {
  if (data.length === 0) {
    return data;
  }

  // Calculate the time span in days
  const firstDate = parseISO(data[0].date);
  const lastDate = parseISO(data[data.length - 1].date);
  const timespanDays = Math.ceil(
    (lastDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)
  );

  // Calculate target points for roughly weekly sampling (1 point per 7 days)
  const targetPoints = Math.max(Math.ceil(timespanDays / 7), 2); // Minimum 2 points

  if (data.length <= targetPoints) {
    return data;
  }

  // Use D3's quantile-based sampling for better distribution
  const indices = d3.range(0, data.length);
  const quantiles = d3
    .range(targetPoints - 1)
    .map(i => d3.quantile(indices, i / (targetPoints - 1)) || 0);

  // Always include first and last points
  const sampledIndices = [0, ...quantiles.map(Math.floor), data.length - 1];

  // Remove duplicates and sort
  const uniqueIndices = Array.from(new Set(sampledIndices)).sort(
    (a, b) => a - b
  );

  return uniqueIndices.map(i => data[i]);
};
